import { createContext, useContext, useState } from "react";

const EditorGuardContext = createContext(null);

export function EditorGuardProvider({ children }) {
  const [dirty, setDirty] = useState(false);
  return (
    <EditorGuardContext.Provider value={{ dirty, setDirty }}>
      {children}
    </EditorGuardContext.Provider>
  );
}

export const useEditorGuard = () => useContext(EditorGuardContext);

// Ritorna true se la navigazione puÃ² procedere (nessuna modifica o conferma utente).
export function canLeave(dirty) {
  if (!dirty) return true;
  return window.confirm("Hai modifiche non salvate. Vuoi uscire senza salvare?");
}
